module.exports = __webpack_public_path__ + "img/33.b92a7bc4.jpg";